<template>
  <div class="UIAccordion">
    <div class="UIAccordion__header">
      <slot name="toggle-container" :isOpen="isExpanded" :toggle="toggleOpen">
        <UIAccordionToggle :isOpen="isExpanded" @toggle="toggleOpen">
          <slot name="toggle" />
        </UIAccordionToggle>
      </slot>
    </div>

    <transition name="accordion">
      <div v-if="isExpanded" class="UIAccordion__content">
        <slot name="content" />
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'

import UIAccordionToggle from './UIAccordionToggle.vue'

const props = withDefaults(defineProps<{ isOpen?: boolean }>(), {
  isOpen: true,
})
const isExpanded = ref(true)

const toggleOpen = () => {
  isExpanded.value = !isExpanded.value
}

watch(
  () => props.isOpen,
  (val) => {
    isExpanded.value = val
  },
  { immediate: true },
)
</script>

<style scoped lang="scss">
.UIAccordion {
  display: flex;
  flex-direction: column;

  .UIAccordion__header {
  }

  .UIAccordion__content {
    margin-top: 0.25rem;
  }
}
</style>
